// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Time units enum.
 */
export enum TimeUnitEnum {
  Second = 0,
  Millisecond = 1,
  Microsecond = 2,
  Nanosecond = 3
}
